import React from "react";

import { Dropdown } from "antd";

import "./styles.scss";

const CustomDropdown = ({ content, trigger, children, placement }) => {
  const actionToDrop = trigger || "hover";
  const dropPlacement = placement || "bottomRight";
  return (
    <Dropdown
      menu={content}
      placement={dropPlacement}
      arrow
      trigger={actionToDrop}
    >
      <div className="custom-dropdown-container">{children}</div>
    </Dropdown>
  );
};

export default CustomDropdown;
